import { useModalContext } from 'utils/contexts/modal';

export enum UPDATE_CUSTOM_EVENT_SETTINGS_ACTION {
  ADD = 'add',
  ALLOW = 'allow',
  BLOCK = 'block',
  DEACTIVATE = 'deactivate',
  DISCARD = 'discard',
  SAVE = 'save',
  UPDATE_RETENTION_PERIOD = 'update-retention-period',
}

export interface ModalState {
  eventNames: string[];
  action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION;
}

export type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState: ModalState | null;
};

export const useModalsContext = () => {
  const { showModal, hideModal, modalState } = useModalContext<ModalState>();

  const showAddModal = () =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.ADD, eventNames: [] });

  const showAllowModal = () =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.ALLOW, eventNames: [] });

  const showBlockModal = () =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.BLOCK, eventNames: [] });

  const showSaveModal = (eventName: string) =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.SAVE, eventNames: [eventName] });

  const showDiscardModal = (eventName: string) =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DISCARD, eventNames: [eventName] });

  const showDeactivateModal = (eventName: string) =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DEACTIVATE, eventNames: [eventName] });

  const showRetentionPeriodModal = (eventNames: string[]) =>
    showModal({ action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.UPDATE_RETENTION_PERIOD, eventNames });

  return {
    showAddModal,
    showAllowModal,
    showBlockModal,
    showSaveModal,
    showDiscardModal,
    showDeactivateModal,
    showRetentionPeriodModal,
    hideModal,
    modalState,
  };
};
